import { PaletteOptions } from "@mui/material/styles";

export const lightPalette: PaletteOptions = {
  mode: "light",
  primary: { main: "#E84B0F" },
};

export const darkPalette: PaletteOptions = {
  mode: "dark",
  primary: { main: "#F8863F" },
};
